const voucherQueryKeys = {
  all: ['all', 'voucher'] as const,
  voucherStatuses: () => [...voucherQueryKeys.all, 'voucherStatus'] as const,
  voucherStatus: (token: string) => [...voucherQueryKeys.voucherStatuses(), token] as const,
  voucherLinksLB: (webOrderId: string) => [...voucherQueryKeys.all, 'voucherLinksLB', webOrderId] as const,
}

export default voucherQueryKeys
